import React, { useState, useEffect } from "react";
import * as Yup from "yup";
import { connect, useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import { useFormik, Form, FormikProvider, Field, FieldArray } from "formik";

import { Input, Select as SelectAnt, Table, Modal, Button, Space, Switch, Tag } from "antd";
import { createPlatforms, updatePlatforms, getPlatformsList } from "../../appRedux/actions/platforms";
import { hideDialog as hideDialogCommon } from "../../appRedux/actions/common";

const { Option } = SelectAnt;
const INITIAL_STATE = {
  name: "",
  code: "",
  faqs: [],
};
function FormView(props) {
  const { platformInfo, queryInfo } = useSelector((state) => ({
    platformInfo: state.platforms.platformInfo,
    queryInfo: state.platforms.queryInfo,
  }));

  // const handleDateChange1 = (date) => {
  //   setSelectedDate1(date);
  // };
  const { isUpdate, reJoin } = props;
  const [formInfo, setFormInfo] = useState(INITIAL_STATE);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isFaqModalOpen, setIsFaqModalOpen] = useState(false);
  const [editingFaqIndex, setEditingFaqIndex] = useState(null);
  const [faqFormValues, setFaqFormValues] = useState({
    question: "",
    answer: "",
    priority: 0,
    isActive: true,
  });

  useEffect(() => {
    // dispatch(hideMessage());
    if (isUpdate && platformInfo && platformInfo._id) {
      setFormInfo({
        ...INITIAL_STATE,
        ...platformInfo,
        faqs: platformInfo.faqs || [],
      });
    } else {
      //console.log("");
      setFormInfo({
        ...INITIAL_STATE,
      });
    }
  }, [isUpdate, platformInfo]);

  const FormSchema = Yup.object().shape({
    name: Yup.string().required("Platform name is required."),
    code: Yup.string().required("Platform code is required."),
    faqs: Yup.array().of(
      Yup.object().shape({
        question: Yup.string().required("Question is required"),
        answer: Yup.string().required("Answer is required"),
        priority: Yup.number().optional(),
        isActive: Yup.boolean().optional(),
      })
    ),
  });
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: formInfo,
    validationSchema: FormSchema,
    onSubmit: (data) => {
      console.log({ data });
      const payload = {
        name: data.name,
        code: data.code,
        faqs: (data.faqs || []).map(f => ({
          question: f.question,
          answer: f.answer,
          priority: Number(f.priority) || 0,
          isActive: f.isActive !== false,
        })),
      };
      if (isUpdate && platformInfo && platformInfo._id) {
        dispatch(
          updatePlatforms({
            ...payload,
            platformId: platformInfo._id,
          })
        ).then(() => {
          dispatch(getPlatformsList(queryInfo)).catch(() => {});
          dispatch(hideDialogCommon());
        }).catch(() => {});
      } else {
        dispatch(
          createPlatforms(payload)
        ).then(() => {
          dispatch(getPlatformsList(queryInfo)).catch(() => {});
          dispatch(hideDialogCommon());
        }).catch(() => {});
      }
    },
  });

  const {
    errors,
    touched,
    values,
    isSubmitting,
    handleChange,
    handleBlur,
    handleSubmit,
    getFieldProps,
    setFieldValue,
  } = formik;
  console.log({ errors, touched, values });

  return (
    <FormikProvider value={formik}>
      <Form
        id="contactForm"
        autoComplete="off"
        noValidate
        onSubmit={handleSubmit}
        className="signin-form"
      >
        {/* <div>
          <label className="col-form-label">
            <b>Course Details:</b>
          </label>
        </div> */}

        <div className="row m-0">
          <div className="col-md-12">
            <div className="input-block mb-3">
              <label className="col-form-label">
                Name <span className="text-danger">*</span>
              </label>
              <input className="form-control" type="text" {...getFieldProps("name")} />
              <p className="error-msg text-danger">{touched.name && errors.name}</p>
            </div>
          </div>

          <div className="col-sm-12">
            <div className="form-group">
              <label className="col-form-label">
                Code<span className="text-danger">*</span>
              </label>
              <input className="form-control" type="text" {...getFieldProps("code")} />
              <p className="error-msg text-danger">{touched.code && errors.code}</p>
            </div>
          </div>

          {/* FAQs Section */}
          <div className="col-md-12 mt-4">
            <div className="d-flex align-items-center justify-content-between mb-3" style={{ borderBottom: "2px solid #f3f4f6", paddingBottom: "12px" }}>
              <h5 className="m-0" style={{ fontWeight: 600, color: "#111827", fontSize: "16px" }}>
                Platform FAQs
              </h5>
              <Button
                type="primary"
                size="small"
                htmlType="button"
                onClick={() => {
                  setEditingFaqIndex(null);
                  setFaqFormValues({ question: "", answer: "", priority: 0, isActive: true });
                  setIsFaqModalOpen(true);
                }}
              >
                <i className="fa fa-plus mr-1" /> Add FAQ
              </Button>
            </div>
            
            <Table
              dataSource={values.faqs || []}
              rowKey={(record, idx) => idx}
              pagination={false}
              size="small"
              columns={[
                {
                  title: "#",
                  render: (_, __, idx) => idx + 1,
                  width: 50,
                },
                {
                  title: "Question",
                  dataIndex: "question",
                  render: (q) => q.length > 60 ? `${q.substring(0, 60)}...` : q,
                },
                {
                  title: "Priority",
                  dataIndex: "priority",
                  width: 80,
                  align: "center",
                },
                {
                  title: "Status",
                  dataIndex: "isActive",
                  width: 100,
                  align: "center",
                  render: (active) => (
                    <Tag color={active ? "success" : "default"}>{active ? "Active" : "Inactive"}</Tag>
                  ),
                },
                {
                  title: "Actions",
                  width: 120,
                  align: "center",
                  render: (_, record, idx) => (
                    <Space size="small">
                      <Button
                        type="text"
                        size="small"
                        htmlType="button"
                        onClick={() => {
                          setEditingFaqIndex(idx);
                          setFaqFormValues({
                            question: record.question || "",
                            answer: record.answer || "",
                            priority: record.priority ?? 0,
                            isActive: record.isActive !== false,
                          });
                          setIsFaqModalOpen(true);
                        }}
                      >
                        Edit
                      </Button>
                      <Button
                        type="text"
                        danger
                        size="small"
                        htmlType="button"
                        onClick={() => {
                          const updated = [...values.faqs];
                          updated.splice(idx, 1);
                          setFieldValue("faqs", updated);
                        }}
                      >
                        Delete
                      </Button>
                    </Space>
                  ),
                },
              ]}
            />

            <Modal
              title={editingFaqIndex !== null ? "Edit FAQ" : "Add FAQ"}
              open={isFaqModalOpen}
              zIndex={2000}
              onCancel={() => setIsFaqModalOpen(false)}
              onOk={() => {
                if (!faqFormValues.question || !faqFormValues.answer) {
                  alert("Question and Answer are required.");
                  return;
                }
                const updated = [...(values.faqs || [])];
                if (editingFaqIndex !== null) {
                  updated[editingFaqIndex] = faqFormValues;
                } else {
                  updated.push(faqFormValues);
                }
                setFieldValue("faqs", updated);
                setIsFaqModalOpen(false);
              }}
              okText="Save FAQ"
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "12px", marginTop: "16px" }}>
                <div>
                  <label style={{ fontWeight: 500, display: "block", marginBottom: "4px" }}>Question <span className="text-danger">*</span></label>
                  <Input
                    placeholder="e.g. What is the cancellation policy?"
                    value={faqFormValues.question}
                    onChange={(e) => setFaqFormValues({ ...faqFormValues, question: e.target.value })}
                  />
                </div>
                <div>
                  <label style={{ fontWeight: 500, display: "block", marginBottom: "4px" }}>Answer <span className="text-danger">*</span></label>
                  <Input.TextArea
                    rows={4}
                    placeholder="e.g. You can cancel anytime from your settings page..."
                    value={faqFormValues.answer}
                    onChange={(e) => setFaqFormValues({ ...faqFormValues, answer: e.target.value })}
                  />
                </div>
                <div style={{ display: "flex", gap: "16px" }}>
                  <div style={{ flex: 1 }}>
                    <label style={{ fontWeight: 500, display: "block", marginBottom: "4px" }}>Priority</label>
                    <Input
                      type="number"
                      min={0}
                      value={faqFormValues.priority}
                      onChange={(e) => setFaqFormValues({ ...faqFormValues, priority: Number(e.target.value) || 0 })}
                    />
                  </div>
                  <div style={{ display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                    <label style={{ fontWeight: 500, marginBottom: "8px" }}>Active Status</label>
                    <div style={{ display: "flex", alignItems: "center", gap: "8px", height: "32px" }}>
                      <Switch
                        checked={faqFormValues.isActive}
                        onChange={(checked) => setFaqFormValues({ ...faqFormValues, isActive: checked })}
                      />
                      <span>{faqFormValues.isActive ? "Active" : "Inactive"}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Modal>
          </div>
        </div>
        <div className="submit-section mb-5">
          <button type="submit" className="btn btn-primary submit-btn">
            {isUpdate && platformInfo && platformInfo._id ? "Update" : "Submit"}
          </button>
        </div>
      </Form>
    </FormikProvider>
  );
}

export default FormView;
